import { SHOW_PRESENTATION_SELECTION } from 'constants/PresentationConstants';

function showPresentationSelection() {
  return {
    type: SHOW_PRESENTATION_SELECTION,
  };
}

export default {
  showPresentationSelection
};